import { inject, injectable } from 'inversify';
import AuthRepository from 'src/features/auth/data/AuthRepository';
import {
  SignUpParams,
  SignUpData,
} from 'src/features/auth/domain/AuthRepositoryInterface';
import { SignUpUseCaseInterface } from 'src/features/auth/domain/useCases/types';

@injectable()
class SignUpUseCase implements SignUpUseCaseInterface {
  @inject(AuthRepository) private authRepository!: AuthRepository;

  async execute(params: SignUpParams): Promise<SignUpData> {
    const sessionData = await this.authRepository.signUp(params);

    return sessionData;
  }
}

export default SignUpUseCase;
